<av-spinner size="xs" *ngIf="loading" [mode]="spinnerMode"></av-spinner>
<ng-content></ng-content>
